import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as participantActions from '../../../actions/participant';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';
import DistanceSelectField from '../../../components/stage/distance-selection';

class PartnersContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            query: '',
            stage: null,
            distance: null
        };
    }

    componentWillMount() {
        this.props.actions.fetchParticipantsPaginated();
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        };
        this.setState(fetchParams);
        this.props.actions.fetchParticipantsPaginated(fetchParams.page, fetchParams.size, {
            query: fetchParams.query,
            stage: fetchParams.stage,
            distance: fetchParams.distance
        });
    }

    handleQueryChange(event) {
        this.fetch({query: event.target.value, page: 0});
    }

    removeParticipant(participant) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deleteParticipant(participant);
        }
    }

    onFilterChange(filterValues) {
        this.fetch({
            distance: filterValues.distance
                ? filterValues.distance.value
                : null,
            stage: filterValues.stage
                ? filterValues.stage.value
                : null,
            page: 0
        });
    }

    render() {
        const {items, total, page, total_pages} = this.props.participants;

        var config = {
            cols: [
                {
                    value: 'displayName',
                    header: `${LocalizedStrings.firstName} ${LocalizedStrings.lastName}`
                }, {
                    value: (item) => {
                        return `${item.payment.price} Eur`
                    },
                    header: LocalizedStrings.price
                }, {
                    value: (item) => {
                        if (item.price === 0) {
                            return LocalizedStrings.isFree;
                        }
                        if (item.payed) {
                            return LocalizedStrings.yes;
                        }
                        return LocalizedStrings.no;
                    },
                    header: LocalizedStrings.payed
                }, {
                    value: (item) => {
                        return item.distance
                            ? `${item.distance.name} (${item.stage
                                ? item.stage.name
                                : ''})`
                            : '';
                    },
                    header: LocalizedStrings.distance
                }, {
                    value: (item) => {
                        return (
                            <div className="btn-group">
                                <Link to={`/admin/participants/${item.id}`}
                                      className="btn">{LocalizedStrings.edit}</Link>
                                <Link to={`/participant/${item.uuid}`}
                                      className="btn">{LocalizedStrings.paymentPage}</Link>
                                <a className="btn btn-red"
                                   onClick={this.removeParticipant.bind(this, item)}>{LocalizedStrings.delete}</a>

                            </div>
                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3 className="first-uppercase">{LocalizedStrings.participants}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/participants/new" className="btn btn-primary">
                        {LocalizedStrings.newParticipant}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <fieldset className="filters">
                            <legend>{LocalizedStrings.filters}</legend>
                            <form>
                                <div className="inline-fields">
                                    <div className="form-row">
                                        <div className="form-field">
                                            <div className="field-control">
                                                <input type="text" value={this.state.query}
                                                       onChange={this.handleQueryChange.bind(this)}
                                                       placeholder={LocalizedStrings.search}/>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className="inline-fields">
                                    <div className="three-selects">
                                        <DistanceSelectField onChange={this.onFilterChange.bind(this)}/>
                                    </div>
                                </div>

                            </form>
                        </fieldset>

                        <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages}
                                   loadAction={this.fetch.bind(this)}></DataTable>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function (state) {
    return {participants: state.participant.participants};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(PartnersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/participant/participants-container.js